import { getCurriedUpdateItemsByPath } from 'shared/helpers/common';
import { CellChange } from 'shared/types/models/EditMetrics';

const updateItemsByPath = getCurriedUpdateItemsByPath<CellChange, number>();
export const updateRowsInChanges = updateItemsByPath(['coordinate', 'row']);
